export default class BookmakerBrandingModel {
  public backgroundColor: string = null;
  public textColor: string = null;
}
